export default __webpack_public_path__ + "static/media/radio_selected.7b46e44d.svg";